import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { STATUS_API, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import { makeStyles } from '@material-ui/core';
import Toolbar from './ToolBar';
import Result from './Result';
import HereDataPanel from './HereDataPanel';
import HereSyncPanel from './HereSyncPanel';
import HereEditPanel from './HereEditPanel';
import AdminOverridePanel from './AdminOverridePanel';
import { getListGeocodeSources } from 'src/features/geocodeSlice';

const GeocodeSourcesTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const query = useQuery();

  const listSources = useSelector(state => state.geocodeSlice.listSources);
  const supportedTypes = useSelector(state => state.geocodeSlice.supportedTypes);
  const statusCreate = useSelector(state => state.geocodeSlice.statusCreate);
  const statusDelete = useSelector(state => state.geocodeSlice.statusDelete);
  const statusUpdate = useSelector(state => state.geocodeSlice.statusUpdate);
  const statusReload = useSelector(state => state.geocodeSlice.statusReload);

  const params = useMemo(() => {
    return {
      page: query.get('page') || 1,
      page_size: PAGE_SIZE_LIST,
      keywords: query.get('keywords') || undefined
    }
  },[query]);

  useEffect(() => {
    dispatch(getListGeocodeSources());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getListSourcesWithParams = query => {
    navigate('/app/manage/geocode-sources?' + _convertObjectToQuery(query));
  };

  useEffect(() => {
    if (statusCreate === STATUS_API.SUCCESS || statusDelete === STATUS_API.SUCCESS || statusUpdate === STATUS_API.SUCCESS || statusReload === STATUS_API.SUCCESS) {
      dispatch(getListGeocodeSources());
    }
  }, [statusCreate, statusDelete, statusUpdate, statusReload]);

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <Toolbar
            searchRef={getListSourcesWithParams}
          />

          <Result
            className="mt-3"
            listSources={listSources}
            supportedTypes={supportedTypes}
            getListSourcesRef={getListSourcesWithParams}
            currentParams={params}
          />

          {/*
            Năm khối trên CÙNG một trang, cùng chủ đề "bản đồ":
              1. Nguồn geocode   — server bản đồ mà ingress gọi ra để tra địa chỉ
                                   (Mongo `geocode_sources`, /geocode/* -> vgps_ingress_api);
              2. Dữ liệu đã thu  — địa chỉ crawl từ HERE, chỉ tra cứu (/osm/here/* -> osm_service);
              3. Cập nhật server — đẩy dữ liệu đó sang các server bản đồ đã cài đặt;
              4. Duyệt sửa       — bù số nhà thiếu vào server bản đồ, phải có người duyệt mới ghi;
              5. Sửa hành chính  — chữa chỗ OSM vẽ sai ranh giới xã/phường, theo VÙNG và phải có
                                   căn cứ pháp lý. KHÔNG dùng dữ liệu HERE cho phần này.
            Khối 2, 3, 4 đi qua CMS vì osm_service nằm trong cluster nội bộ. Việc ĐIỀU KHIỂN thu
            thập không có UI: tiêu quota HERE, chạy nền bằng cron.
          */}
          <HereDataPanel />
          <HereSyncPanel />
          <HereEditPanel />
          <AdminOverridePanel />
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    marginTop: '17px'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

export default GeocodeSourcesTable;